import { memo } from 'react'
import Select from 'react-select'
import { PicklistStatusDesc } from '../constants/EnumType'

const SelectOption = ({ 
  title, optionEnum, value, onChanged, className = ''
}: { title: string, optionEnum: string[], value: string, className?: string
  onChanged : (value: string) => void }) => {
  return <div className={className}>
    <small className='text-muted'>{title}</small>
    <Select
      value={{ value, label: getValueByKeyForStringEnum(value) }}
      onChange={(e) => onChanged(e?.value || '')}
      options={optionEnum.map(value => {
        return { value: value, label: getValueByKeyForStringEnum(value) }
      })}
      isSearchable={false}
      menuPortalTarget={document.body}
      styles={{ 
        menuPortal: base => ({ ...base, zIndex: 9999 })
      }}
    />
  </div>
}

function getValueByKeyForStringEnum(value: string) {
  if (value === '') return 'ไม่ระบุ'
  return Object.entries(PicklistStatusDesc).find(([key, val]) => key === value)?.[1] || value;
}

export default memo(SelectOption)